<template>
  <div class="card">
    <div class="card-body">
      <h5 class="mb-4" v-if="data.name || data.surname">
        <strong>{{
          (data.name ? data.name : '') +
          (data.surname ? (data.name ? ' ' : '') + data.surname : '')
        }}</strong>
      </h5>
      <div class="bg-light rounded-lg p-5">
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <a-form :form="form">
              <div
                v-if="data.image_filename != undefined"
                style="text-align: center; padding-bottom: 3rem"
              >
                <img
                  :src="`${public_path}user_images/avatar/${data.image_filename}`"
                  style="width: 192px"
                />
              </div>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Prefix')"
              >
                <a-input
                  :disabled="data.validated == 1"
                  :placeholder="$t('Prefix')"
                  v-decorator="[
                    'prefix',
                    {
                      initialValue: data.prefix,
                      rules: [
                        {
                          required: true,
                          message: `${$t('Please input your ')}${$t(
                            'Prefix'
                          )}!`,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Name')"
              >
                <a-input
                  :disabled="data.validated == 1"
                  :placeholder="$t('Name')"
                  v-decorator="[
                    'fname',
                    {
                      initialValue: data.fname,
                      rules: [
                        {
                          required: true,
                          message: `${$t('Please input your ')}${$t('Name')}!`,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Surname')"
              >
                <a-input
                  :disabled="data.validated == 1"
                  :placeholder="$t('Surname')"
                  v-decorator="[
                    'sname',
                    {
                      initialValue: data.sname,
                      rules: [
                        {
                          required: true,
                          message: `${$t('Please input your ')}${$t(
                            'Surname'
                          )}!`,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Username')"
              >
                <a-input
                  :placeholder="$t('Username')"
                  v-decorator="[
                    'username',
                    {
                      initialValue: data.username,
                      rules: [
                        {
                          required: true,
                          message: `${$t('Please input your ')}${$t(
                            'Username'
                          )}!`,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Password')"
              >
                <a-input
                  :placeholder="$t('Password')"
                  v-decorator="[
                    'password',
                    {
                      initialValue: data.password,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Password Confirmation')"
              >
                <a-input
                  :placeholder="$t('Password Confirmation')"
                  v-decorator="[
                    'password_confirmation',
                    {
                      initialValue: data.password_confirmation,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Mobile')"
              >
                <a-input
                  :placeholder="$t('Mobile')"
                  v-decorator="[
                    'tel',
                    {
                      initialValue: data.tel,
                      rules: [
                        {
                          required: true,
                          message: `${$t('Please input your ')}${$t(
                            'Mobile'
                          )}!`,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('Email')"
              >
                <a-input
                  :placeholder="$t('Email')"
                  v-decorator="[
                    'email',
                    {
                      initialValue: data.email,
                      rules: [
                        {
                          required: false,
                          message: '',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('LINE Notify')"
              >
                <a-button
                  v-if="!data.line_notify_token"
                  type="button"
                  class="btn btn-success"
                  @click="lineNotify"
                >
                  {{ $t('Connect') }}
                </a-button>
                <a-button
                  v-if="data.line_notify_token"
                  type="danger"
                  @click="disconnectLineNotify"
                >
                  {{ $t('Disconnect') }}
                </a-button>
              </a-form-item>
              <a-form-item
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                :label="$t('LINE Login')"
              >
                <a-button
                  v-if="!data.line_user_id"
                  type="button"
                  class="btn btn-success"
                  @click="lineLogin"
                >
                  {{ $t('Connect') }}
                </a-button>
                <a-button
                  v-if="data.line_user_id"
                  type="danger"
                  @click="disconnectLineLogin"
                >
                  {{ $t('Disconnect') }}
                </a-button>
              </a-form-item>
              <div class="border-top pt-4 row">
                <div class="offset-3">
                  <a-button
                    style="text-algin: center"
                    type="primary"
                    htmlType="button"
                    @click="onSubmit"
                    :loading="submitting"
                  >
                    {{ $t('Save') }}
                  </a-button>
                </div>
                <!-- <div>
                  <a-button
                    style="text-algin: center; margin-left: 1rem"
                    type="danger"
                    htmlType="button"
                    @click="onDeleteUser"
                    :loading="deleteing"
                  >
                    {{ $t('Delete User') }}
                  </a-button>
                </div> -->
              </div>
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="activities_data && activities_data.length > 0">
      <h5 class="mb-4">
        <strong>{{ $t('Activities') }}</strong>
      </h5>
      <div class="bg-light rounded-lg p-5">
        <div class="mb-4">
          <a-button
            v-for="(item, index) in activities_data"
            :key="item.name"
            type="button"
            class="btn btn-light mr-2 mb-2"
            :class="[
              selected_activity_index === index
                ? 'bg-primary text-white'
                : 'text-primary',
            ]"
            style="border-color: #e4e9f0"
            @click="getActivityHistory(1, index)"
            :loading="getting_activity_history[index]"
          >
            {{ item.name }}
          </a-button>
        </div>
        <a-table
          :columns="activity_history_columns"
          :dataSource="activity_history_data"
          :pagination="false"
          :locale="table_locale"
        >
          <template slot="createdAt" slot-scope="text, row">
            <div>
              <div>{{ dateThai(text, row) }}</div>
              <!-- <div class="text-gray-4">{{ user.position }}</div> -->
            </div>
          </template>
          <a
            slot="actions"
            slot-scope="text, row"
            href="javascript: void(0);"
            class="btn btn-sm btn-danger"
            @click="userInfo(row.id)"
          >
            {{ $t('Remove') }}
          </a>
        </a-table>
        <div class="col-md-12" style="padding: 1.33rem 0">
          <a-pagination
            v-model="currentPage"
            :total="maxPage"
            @change="getActivityHistory"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { Modal } from 'ant-design-vue';
import moment from 'moment';
// import '@team-decorate/dist/vue-line-login.css';
// import VueLineLogin from '@team-decorate/vue-line-login';
/* import store from 'store'; */
const labelCol = {
  xs: { span: 24 },
  sm: { span: 12 },
};
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
};
const marks = {
  0: '0',
  10: '10',
  20: '20',
  30: '30',
  40: '40',
  50: '50',
  60: '60',
  70: '70',
  80: '80',
  90: '90',
  100: '100',
};
const residences = [
  {
    value: 'zhejiang',
    label: 'Zhejiang',
    children: [
      {
        value: 'hangzhou',
        label: 'Hangzhou',
        children: [
          {
            value: 'xihu',
            label: 'West Lake',
          },
        ],
      },
    ],
  },
  {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [
      {
        value: 'nanjing',
        label: 'Nanjing',
        children: [
          {
            value: 'zhonghuamen',
            label: 'Zhong Hua Men',
          },
        ],
      },
    ],
  },
];
export default {
  // components: {
  //   VueLineLogin,
  // },
  data: function () {
    const activity_history_columns = [
      {
        title: '#',
        dataIndex: 'row_number',
        scopedSlots: { customRender: 'row_number' },
      },
      {
        title: this.$t('Date and Time'),
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'createdAt' },
        sorter: (a, b) => a.created_at_timestamp - b.created_at_timestamp,
      },
      {
        title: this.$t('Distance'),
        dataIndex: 'distance_with_unit',
        scopedSlots: { customRender: 'distance_with_unit' },
        sorter: (a, b) => a.distance - b.distance,
      },
      {
        title: this.$t('Time Usage'),
        dataIndex: 'time_usage_with_unit',
        scopedSlots: { customRender: 'time_usage_with_unit' },
        sorter: (a, b) => a.timeUsage - b.timeUsage,
      },
      {
        title: this.$t('Calorie(s)'),
        dataIndex: 'calories',
        scopedSlots: { customRender: 'calories' },
        sorter: (a, b) => a.calories - b.calories,
      },
      {
        title: this.$t('HP'),
        dataIndex: 'hp',
        scopedSlots: { customRender: 'hp' },
        sorter: (a, b) => a.hp - b.hp,
      },
      /* {
        title: this.$t('Actions'),
        dataIndex: 'actions',
        scopedSlots: { customRender: 'actions' },
      }, */
    ];
    return {
      mode: process.env.NODE_ENV,
      public_path: process.env.VUE_APP_PUBLIC_PATH,
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      marks,
      residences,
      data: {},
      submitting: false,
      deleteing: false,
      activities_data: [],
      selected_activity_index: 0,
      getting_activity_history: [],
      currentPage: 1,
      maxPage: 1,
      default_activity_history_columns: activity_history_columns,
      activity_history_columns,
      activity_history_data: [],
      table_locale: {
        filterConfirm: this.$t('Ok'),
        filterReset: this.$t('Reset'),
        emptyText: this.$t('No Data'),
      },
      goal_types: [
        'Unknown',
        'HP_TYPE_FROM_OLD',
        'HP_TYPE_NEW_REGISTER',
        'HP_TYPE_REFERENCE',
        'HP_TYPE_ACTIVITY',
        'HP_TYPE_VERIFIED',
        'Exercise All Over 800m',
        'Run Over 80km',
        'Bike Over 300km',
        'Exercise All Over 6000cal',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
        'Unknown',
      ],
      line_notify_connecting: false,
    };
  },
  mounted() {
    /* this.getUserInfo(() =>
      this.getActivities(() => this.getActivityHistory(1, 0))
    ); */
    // this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT');
    // this.data = this.$store.state.user;
    // console.log('this.data -->', this.data);
    /* this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT'); */
    const self = this;
    self.getUserInfo();
    setInterval(() => {
      if (self.line_notify_connecting && !self.data.line_notify_token) {
        self.getUserInfo();
      }
    }, 1000);
  },
  methods: {
    getUserInfo: function (callback = null) {
      this.$store.dispatch('user/GET', {
        payload: {
          path: '/api/console/users/profile',
          data: {},
          callback: (res) => {
            if (res && res.data) this.data = res.data;
            if (typeof callback == 'function') callback();
          },
        },
      });
    },
    getActivities: function (callback = null) {
      this.$store.dispatch('user/POST', {
        payload: {
          path: '/api/findActivities',
          callback: (res) => {
            if (res && _.isArray(res.data) && !_.isEmpty(res.data)) {
              this.activities_data = res.data;
              for (let i = 0; i < res.data.length; i++) {
                this.getting_activity_history.push(false);
              }
              if (typeof callback == 'function') callback();
            }
          },
        },
      });
    },
    getActivityHistory: function (
      currentPage = null,
      selected_activity_index = null
    ) {
      const self = this;
      if (_.includes(self.getting_activity_history, true)) return;
      if (typeof currentPage != 'number') currentPage = self.currentPage;
      if (typeof selected_activity_index == 'number')
        self.selected_activity_index = selected_activity_index;
      self.getting_activity_history[self.selected_activity_index] = true;
      self.$store.dispatch('user/POST', {
        payload: {
          path: '/api/activityUser/list',
          data: {
            pageNo: currentPage,
            itemPerPage: 20,
            activityId: self.activities_data[self.selected_activity_index].id,
            userId: self.data.id,
          },
          callback: (res) => {
            if (res && res.data) {
              self.currentPage = res.data.currentPage;
              self.maxPage = res.data.maxPage * 10;
              if (_.isArray(res.data.activities)) {
                self.activity_history_data = _.filter(
                  res.data.activities,
                  (v, k) => {
                    v.row_number =
                      (self.currentPage > 1 ? 20 * (self.currentPage - 1) : 0) +
                      k +
                      1;
                    v.created_at_timestamp = moment(v.createdAt).format('x');
                    if (Number(v.activityUnitType) == 1) {
                      self.activity_history_columns =
                        self.default_activity_history_columns;
                      v.distance_with_unit = `${v.distance} ${self.$t(
                        'Kilometer(s)'
                      )}`;
                    } else {
                      self.activity_history_columns = _.filter(
                        self.default_activity_history_columns,
                        (col) => col.dataIndex !== 'distance_with_unit'
                      );
                    }
                    v.time_usage_with_unit = `${v.timeUsage} ${self.$t(
                      'Minute(s)'
                    )}`;
                    return v;
                  }
                );
              }
            }
            self.getting_activity_history[self.selected_activity_index] = false;
          },
        },
      });
    },
    onBirthDateChange: function (date, dateString) {
      this.data.birthDate = dateString;
    },
    onSubmit: function () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true;
          const data = { ...this.data, ...values };
          /* const data = {
            acode: '4401',
            aname: 'อำเภอเมืองมหาสารคาม',
            birthDate: null,
            bmi: 0,
            cardId: '370980020436787370980020436787',
            currentACode: null,
            currentHouseNo: null,
            currentMoo: '',
            currentPCode: null,
            currentPostalCode: null,
            currentSoi: null,
            currentStreet: null,
            currentTCode: null,
            currentVillage: null,
            ebib: 168431,
            email: '',
            gender: null,
            height: 0,
            houseNo: null,
            hp: 0.66,
            hpValidated: 8,
            id: 'a9baa6f1-5d52-4c7b-a861-0491769348e0',
            image_filename: null,
            lineId: '',
            mobile: '0801903980',
            moo: '6',
            name: 'พรม',
            password: '==========NoCHanGe=====',
            pcode: '44',
            pname: 'มหาสารคาม',
            postalCode: null,
            shirtSize: null,
            soi: null,
            street: null,
            surname: 'ฉิมเอี่ยม',
            tcode: '44011200',
            tname: 'ตำบลห้วยแอ่ง',
            totalCalories: 65.52,
            totalHp: 8.66,
            userType: 0,
            username: '0801903980',
            validated: 0,
            village: null,
            weight: 0,
          }; */
          /* const data = _.pickBy({ ...this.data, ...values }, _.identity); */
          delete data.image_filename;
          delete data.line_notify_token;
          delete data.line_user_id;
          this.$store.dispatch('user/POST', {
            payload: {
              path: '/api/console/users/profile',
              data,
              callback: (res) => {
                this.submitting = false;
                if (res && res.success) {
                  this.$notification.success({
                    message: this.$t('Save Success!'),
                  });
                } else {
                  const error = {
                    message: this.$t('Save Fail!'),
                  };
                  if (
                    res &&
                    _.isArray(res.messages) &&
                    !_.isEmpty(res.messages)
                  ) {
                    _.filter(res.messages, (v, k) => {
                      if (k == 0) {
                        error.description = v;
                      } else {
                        error.description += ', ' + v;
                      }
                    });
                  }
                  this.$notification.error(error);
                }
              },
            },
          });
        }
      });
    },
    onDeleteUser() {
      const self = this;
      Modal.confirm({
        title: this.$t('Are you sure delete this user?'),
        /* content: 'Some descriptions', */
        okText: this.$t('Ok'),
        okType: 'danger',
        cancelText: this.$t('Cancel'),
        onOk() {
          self.deleteing = true;
          const data = { username: self.data.username };
          self.$store.dispatch('user/POST', {
            payload: {
              path: '/api/users/deleteUser',
              data,
              callback: (res) => {
                self.deleteing = false;
                if (res && res.result === 1) {
                  self.$notification.success({
                    message: self.$t('Delete Success!'),
                  });
                  self.$router.replace({
                    path: '/main-menu/find-users',
                  });
                } else {
                  const error = {
                    message: self.$t('Delete Fail!'),
                  };
                  if (
                    res &&
                    _.isArray(res.messages) &&
                    !_.isEmpty(res.messages)
                  ) {
                    _.filter(res.messages, (v, k) => {
                      if (k == 0) {
                        error.description = v;
                      } else {
                        error.description += ', ' + v;
                      }
                    });
                  }
                  self.$notification.error(error);
                }
              },
            },
          });
        },
        onCancel() {
          /* console.log('Cancel'); */
        },
      });
    },
    dateThai(date, row) {
      /* 0d3293a3-ca06-48f7-bec9-e87820b8bcd7 */
      const splited_date = moment(date).lang('th').format('LLL').split(' ');
      splited_date[2] = Number(splited_date[2]) + 543;
      return `${splited_date[0]} ${splited_date[1]} ${splited_date[2]} ${splited_date[3]} ${splited_date[4]}`;
    },
    lineNotify() {
      this.line_notify_connecting = true;
      const url = `https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=cMrLoykucdNuR65tUnsObW&redirect_uri=${encodeURI(
        `${this.$apiUrl}/api/line-callback`
      )}&scope=notify&state=${
        this.$store.state.user.user_id
      }&response_mode=form_post`;
      window.open(url, '_blank');
    },
    lineLogin() {
      const url = `https://access.line.me/dialog/oauth/weblogin?response_type=code&client_id=1655218347&redirect_uri=${encodeURI(
        `${window.location.origin}/project-management`
      )}`;
      window.open(url, '_self');
    },
    disconnectLineNotify() {
      this.line_notify_connecting = false;
      this.form.validateFields((err, values) => {
        if (!err) {
          /* this.submitting = true; */
          const data = {
            ...this.data,
            ...values,
            line_notify_token: 'destroy',
          };
          delete data.image_filename;
          delete data.line_user_id;
          this.$store.dispatch('user/POST', {
            payload: {
              path: '/api/console/users/profile',
              data,
              callback: (res) => {
                this.submitting = false;
                if (res && res.success) {
                  this.getUserInfo();
                  /* this.$notification.success({
                    message: this.$t('Save Success!'),
                  }); */
                } else {
                  const error = {
                    message: this.$t('Save Fail!'),
                  };
                  if (
                    res &&
                    _.isArray(res.messages) &&
                    !_.isEmpty(res.messages)
                  ) {
                    _.filter(res.messages, (v, k) => {
                      if (k == 0) {
                        error.description = v;
                      } else {
                        error.description += ', ' + v;
                      }
                    });
                  }
                  this.$notification.error(error);
                }
              },
            },
          });
        }
      });
    },
    disconnectLineLogin() {
      this.form.validateFields((err, values) => {
        if (!err) {
          /* this.submitting = true; */
          const data = {
            ...this.data,
            ...values,
            line_user_id: 'destroy',
          };
          delete data.image_filename;
          delete data.line_notify_token;
          this.$store.dispatch('user/POST', {
            payload: {
              path: '/api/console/users/profile',
              data,
              callback: (res) => {
                this.submitting = false;
                if (res && res.success) {
                  this.getUserInfo();
                  /* this.$notification.success({
                    message: this.$t('Save Success!'),
                  }); */
                } else {
                  const error = {
                    message: this.$t('Save Fail!'),
                  };
                  if (
                    res &&
                    _.isArray(res.messages) &&
                    !_.isEmpty(res.messages)
                  ) {
                    _.filter(res.messages, (v, k) => {
                      if (k == 0) {
                        error.description = v;
                      } else {
                        error.description += ', ' + v;
                      }
                    });
                  }
                  this.$notification.error(error);
                }
              },
            },
          });
        }
      });
    },
  },
};
</script>
